import { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { EyeOutlined, EditOutlined } from '@ant-design/icons';
import { message } from 'antd';
import './TemplateItem.scss';
import { ModalPdf } from 'components/ModalPdf/ModalPdf';
import { Button, Tooltip } from 'components';
import { convertirTipoPlantillaTipoMonitoreo } from 'utils/convertirTipoPlantillaTipoMonitoreo';
import { getPdfActa } from 'actions/pdf.actions';
import CustomizeImage from 'components/CustomizeImage/CustomizeImage';
import { MONITOREOS_INTERNET, MONITOREOS_MEDIOS_IMPRESOS } from 'constants/tipoMonitoreos';
import { PDF_INTERNET, PDF_MEDIOS_IMPRESOS } from 'constants/pdfTypes';
import { REGULAR_DATE_FORMAT } from 'constants/dateFormat';
import dayjs from 'dayjs';
import image from '../../../../assets/images/fondo_edicion.svg';

const TemplateItem = ({ plantilla, title }) => {
  const navigate = useNavigate();
  const [isModalPDFOpen, setIsModalPDFOpen] = useState(false);
  const [pdfActa, setPdfActa] = useState(null);
  const [tipoActa, setTipoActa] = useState(null);
  const dispatch = useDispatch();

  const handleEditTemplate = () => {
    navigate(`/simac/edicionPlantillas/${plantilla.idPlantilla}`);
  };

  const obtainTipoActa = (tipoActaTipoMonitoreo) => {
    switch (tipoActaTipoMonitoreo.tipoMonitoreo) {
      case MONITOREOS_INTERNET:
        return PDF_INTERNET;
      case MONITOREOS_MEDIOS_IMPRESOS:
        return PDF_MEDIOS_IMPRESOS;
      default:
        return tipoActaTipoMonitoreo.tipoActa;
    }
  };

  const handleGetPdfActa = async () => {
    const payload = convertirTipoPlantillaTipoMonitoreo(plantilla.idPlantilla);
    payload.tipoDescarga = 1;
    payload.listaIdMonitoreos = [];
    payload.ejemploPDF = 1;
    try {
      const { success, response } = await dispatch(getPdfActa(payload));

      const { archivo } = response.data;
      if (success) {
        setPdfActa(archivo);
        setTipoActa(obtainTipoActa(payload));
        setIsModalPDFOpen(true);
      }
    } catch (error) {
      message.error('Error al obtener el PDF', 3);
    }
  };

  return (
    <div className="container-template-item ">
      {isModalPDFOpen && (
        <ModalPdf
          open={isModalPDFOpen}
          ultimaActualizacion={dayjs(plantilla.fecha_hora).format(REGULAR_DATE_FORMAT)}
          usuario={plantilla.usuario}
          titulo={plantilla.nombre}
          pdfActa={pdfActa}
          tipoActa={tipoActa}
          callback={() => setIsModalPDFOpen(false)}
          destroyOnClose
        />
      )}
      <CustomizeImage imageUrl={image} title={title} subtitle={plantilla.nombre} />
      <div className="actions-container">
        <Tooltip title="Consultar" class="tooltip-acciones" placement="topLeft">
          <Button
            className="button-action"
            type="primary"
            onClick={() => handleGetPdfActa()}
            icon={<EyeOutlined />}
            ghost
          />
        </Tooltip>
        <Tooltip title="Editar" class="tooltip-acciones" placement="topLeft">
          <Button
            className="button-action"
            type="primary"
            onClick={() => handleEditTemplate()}
            icon={<EditOutlined />}
            ghost
          />
        </Tooltip>
      </div>
    </div>
  );
};

TemplateItem.propTypes = {
  plantilla: PropTypes.shape({
    nombre: PropTypes.string.isRequired,
    idPlantilla: PropTypes.number.isRequired,
    fecha_hora: PropTypes.string.isRequired,
    usuario: PropTypes.string.isRequired
  }).isRequired,
  title: PropTypes.string.isRequired
};

export default TemplateItem;
